import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RejectReviewService } from '../../services/raintree/Transmission/reject-review.service';
import { DpSuccessMessageComponent } from '../../common-component/dp-success-message/dp-success-message.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-accept-dialogue',
  standalone: true,
  imports: [
    MatDialogModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
  ],
  templateUrl: './accept-dialogue.component.html',
  styleUrl: './accept-dialogue.component.scss',
})
export class AcceptDialogueComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private rejectService: RejectReviewService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<AcceptDialogueComponent>
  ) { }
  queryParams: any = { ...this.route.snapshot.queryParams };

  acceptDatum() {
    let bodyObj = {
      approved: true,
      rejected: false,
      uiState: this.queryParams['state'],
      uiDistrict: this.queryParams['district'],
    };
    if (this.data.review)
      bodyObj = { ...bodyObj, ...this.data.reqBody }
    console.log(bodyObj);

    this.rejectService.rejectMemdata(this.data.data, bodyObj).subscribe({
      next: (response) => {
        console.log(response);
        this.dialog.open(DpSuccessMessageComponent, {
          panelClass: 'common-pannel-dialog-container',
          data: {
            mainHeading: `Data approved successfully!`,
            subHeading: '',
            buttonValue: 'Done',
            reload: true,
          },
        });
        this.dialogRef.close(true);
      },
      error: (error) => {
        console.log(error);
      },
    });
  }
}
